<template>
  <div class="d-flex h-100">
    <div class="d-flex flex-column" id="options-bar" style="flex: 1" v-if="!readonly" >
      <form id="edit_custom_styles" @submit.prevent="saveSettings()" class="d-flex flex-column fullheight">
        <div class="d-flex spaced-xs">
          <div style="flex: 1;">
            <a :href="'/creator/'+websiteid"><span class="ico material-icons" style="vertical-align: -7px;">chevron_left</span>Terug naar site</a>
          </div>
          <button type="submit" class="btn btn-primary">Opslaan</button>
        </div>
        <div style="flex: 1; overflow: auto;">
          <div class="inspector-card">
            <h3 class="inspector-header">Kleuren</h3>
            <div class="field-comb">
              <label class="field-ico">Teksten in  menu</label>
              <select style="flex: 1;" class="field-input" v-model="settingspage.menucolortheme">
                <option value="light">Lichte tekst op een donkere achtergrond</option>
                <option value="dark">Donkere tekst op een lichte achtergrond</option>
              </select>
            </div>
            <div class="field-comb">
              <label class="field-ico">Kleur menu</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.menucolor" placeholder="Enter color...">
              <input class="field-input-color" type="color" v-model="settingspage.menucolor">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> #00b1dd</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Breedte menu</label>
              <select style="flex: 1;" class="field-input" v-model="settingspage.menuwidth">
                <option value="full">Volledige breedte</option>
                <option value="detached">Van de rand af</option>
                <option value="content">Even breed als teksten</option>
              </select>
            </div>
            <div class="field-comb">
              <label class="field-ico">Achtergrondkleur homepage</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.bghero" placeholder="Enter color...">
              <input class="field-input-color" type="color" v-model="settingspage.bghero">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> #00b1dd</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Tekstkleur homepage</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.texthero" placeholder="Enter color...">
              <input class="field-input-color" type="color" v-model="settingspage.texthero">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> #00b1dd</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Links op wit</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.linkcolor" placeholder="Enter color...">
              <input class="field-input-color" type="color" v-model="settingspage.linkcolor">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> #00b1dd</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Links op donker</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.linkcolordark" placeholder="Enter color...">
              <input class="field-input-color" type="color" v-model="settingspage.linkcolordark">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> #99b1dd</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Buttons</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.buttoncolor" placeholder="Enter color...">
              <input class="field-input-color" type="color" v-model="settingspage.buttoncolor">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> #00b1dd</div>
            </div>
          </div>
          <div class="inspector-card">
            <h3 class="inspector-header">Layout</h3>
            <label class="d-flex m-0 mb-2" style="flex: 1; align-items: baseline;">
              <input type="checkbox" v-model="settingspage.use_one_pager" style="margin-right: 10px;"> Gebruik een one-pager
            </label>
            <label class="d-flex m-0 mb-2" style="flex: 1; align-items: baseline;">
              <input type="checkbox" v-model="settingspage.herofullheight" style="margin-right: 10px;"> Intro op homepage minder hoog
            </label>
            <div class="field-comb">
              <label class="field-ico">Uitlijnen intro</label>
              <select style="flex: 1;" class="field-input" v-model="settingspage.heroalign">
                <option value="left">Links</option>
                <option value="center">Midden</option>
                <option value="right">Rechts</option>
              </select>
            </div>
            <div class="field-comb">
              <label class="field-ico">Lettertypen</label>
              <select style="flex: 1;" class="field-input" v-model="settingspage.fontstyle">
                <option value="regular">Normaal</option>
                <option value="friendly">Vriendelijk</option>
                <option value="business">Zakelijk</option>
                <option value="serif">Serif</option>
                <option value="bold">Bold</option>
                <option value="caps">Hoofdletters</option>
              </select>
            </div>
            <div class="field-comb">
              <label class="field-ico">Google Fonts</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.googlefont" placeholder="Enter google font URL...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700|Varela+Round</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Knoptekst (op homepage)</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.ctatext" placeholder="Text on the button...">
              <div class="field-help"><span class="help-caption">Hulp:</span> Dit is de knop die je op de homepage ziet.</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Knoplink (op homepage)</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.ctalink" placeholder="URL...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> https://mijnsite.nl/contact</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Knoptekst (naast menu)</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.ctamenutext" placeholder="Text on the button...">
              <div class="field-help"><span class="help-caption">Hulp:</span> Dit is de knop die je naast het menu ziet.</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Knoplink (naast menu)</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.ctamenulink" placeholder="URL...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> https://mijnsite.nl/contact</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Overgangen blokken</label>
              <select style="flex: 1;" class="field-input" v-model="settingspage.blockseparator">
                <option value="odd">Oneffen kleuren</option>
                <option value="line">Lijn</option>
                <option value="none">Geen</option>
              </select>
            </div>
          </div>
          <div class="inspector-card">
            <h3 class="inspector-header">SEO &amp; Analytics</h3>
            <label class="d-flex m-0 mb-2" style="flex: 1; align-items: baseline;">
              <input type="checkbox" v-model="settingspage.use_analytics" style="margin-right: 10px;"> Gebruik Google Analytics
            </label>
            <div class="field-comb">
              <label class="field-ico">Analytics code</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.code_analytics" placeholder="Starts with UA...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> UA-937659-01</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Site titel</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.site_title" placeholder="Title of the website">
              <div class="field-help"><span class="help-caption">Hulp:</span> Dit is de titel die Google zoekresultaten zal tonen</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Beschrijving</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.site_description" placeholder="Meta description...">
              <div class="field-help"><span class="help-caption">Hulp:</span> Dit is de beschrijving die Google zoekresultaten zal tonen</div>
            </div>
          </div>
          <div class="inspector-card">
            <h3 class="inspector-header">Eigen stylesheet</h3>
            <label class="d-flex m-0 mb-2" style="flex: 1; align-items: baseline;">
              <input type="checkbox" v-model="settingspage.use_stylesheet" style="margin-right: 10px;"> Gebruik een eigen stylesheet
            </label>
            <div class="field-comb">
              <a :href="'/creator/'+websiteid+'/customstylepage'" class="btn btn-outline-primary">Stylesheet aanpassen</a>
            </div>
            <div class="field-comb">
              <label class="field-ico">Thema</label>
              <select style="flex: 1;" class="field-input" v-model="settingspage.theme">
                <option value="default">Standaard</option>
                <option value="white">Wit eenvoudig</option>
                <option value="business">Zakelijk</option>
              </select>
              <div class="field-help"><span class="help-caption">Hulp:</span> Kies een thema</div>
            </div>
          </div>
          <div class="inspector-card">
            <h3 class="inspector-header">Logo</h3>
            <div class="field-comb">
              <label class="field-ico">Logo</label>
              <div style="flex: 1; justify-content: space-between" class="field-input flex-row">
                <span>
                  <img v-if="settingspage.logoimage" :src="settingspage.logoimage" style="height: 40px" alt=""/>
                </span>
                <span class="flex-row">
                  <button @click.prevent="imageModal = true, getimages(), imagetarget = 'logo'" class="btn btn-link">Upload logo</button>
                  <button v-if="settingspage.logoimage" @click.prevent="settingspage.logoimage = ''" class="btn btn-link">Verwijderen</button>
                </span>
              </div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Logo hoogte</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.logoheight" placeholder="bijv: 70">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> 70</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Logo hoogte bij scrollen</label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.logoheightscroll" placeholder="bijv: 40">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> 40</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Favicon</label>
              <div style="flex: 1; justify-content: space-between" class="field-input flex-row">
                <span>
                  <img v-if="settingspage.favicon" :src="settingspage.favicon" style="height: 40px" alt=""/>
                </span>
                <span class="flex-row">
                  <upload-modal @clicked="setfavicon" :websiteid="websiteid" returnvalue="true" thestyle="btn btn-link">Upload favicon</upload-modal>
                  <button v-if="settingspage.favicon" @click.prevent="settingspage.favicon = ''" class="btn btn-link">Verwijderen</button>
                </span>
              </div>
            </div>
          </div>
          <div class="inspector-card">
            <h3 class="inspector-header">Social media</h3>
            <div class="field-comb">
              <label class="field-ico"><span class="ico ico-svg svg-facebook"></span></label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.facebookurl" placeholder="Facebook url...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> https://facebook.com/phabsitenl</div>
            </div>
            <div class="field-comb">
              <label class="field-ico"><span class="ico ico-svg svg-twitter"></span></label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.twitterurl" placeholder="Twitter url...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> https://twitter.com/phabsitenl</div>
            </div>
            <div class="field-comb">
              <label class="field-ico"><span class="ico ico-svg svg-instagram"></span></label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.instagramurl" placeholder="Instagram url...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> https://instagram.com/phabsitenl</div>
            </div>
            <div class="field-comb">
              <label class="field-ico"><span class="ico ico-svg svg-youtube"></span></label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.youtubeurl" placeholder="Youtube url...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> https://youtube.com/phabsitenl</div>
            </div>
            <div class="field-comb">
              <label class="field-ico"><span class="ico ico-svg svg-soundcloud"></span></label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.soundcloudurl" placeholder="Soundcloud url...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> https://soundcloud.com/phabsitenl</div>
            </div>
            <div class="field-comb">
              <label class="field-ico"><span class="ico ico-svg svg-telegram"></span></label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.telegramurl" placeholder="Telegram url...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span> https://telegram.com/phabsitenl</div>
            </div>
            <div class="field-comb">
              <label class="field-ico"><span class="ico ico-svg svg-whatsapp"></span></label>
              <input style="flex: 1;" class="field-input" type="text" v-model="settingspage.whatsappurl" placeholder="Whatsapp url...">
              <div class="field-help"><span class="help-caption">Voorbeeld:</span>https://wa.me/+31643040607</div>
            </div>
            <div class="field-comb">
              <label class="field-ico">Tonen:</label>
              <select style="flex: 1;" class="field-input" v-model="settingspage.sociallocation">
                <option value="inmenu">In menu en footer</option>
                <option value="onhome">Op homepageplaatje en footer</option>
              </select>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="d-flex" style="flex: 2;" id="iframecontainer">
      <iframe id="userframe" class="align-self-stretch w-100 border-0" :src="'/viewer/'+websiteid">
      </iframe>
    </div>

    <modal v-if="imageModal" @close="imageModal = false" title="Logo aanpassen">
        <ul class="imageselector">
            <li>
                <upload-modal @clicked="getimages()" :websiteid="websiteid" thestyle="imageuploadbutton btn btn-primary"><span class="material-icons ico">add_circle</span> Upload</upload-modal>
            </li>
            <li v-for="image in images">
                <button class="imagethumb" @click.prevent="setblockimage(image.image)" :style="'background-image: url('+ imageroot + image.image.split('uploads/').pop() +')'">
                    <span>{{ image.image }}</span>
                </button>
            </li>
        </ul>
        <form v-if="!readonly" id="blockimage" @submit.prevent="imageModal = false">
            <button type="submit" class="btn btn-primary">Opslaan</button>
        </form>
    </modal>
  </div>
</template>

<script>
  import InputDefault from '../components/form/InputDefault.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';
  import Modal from '../components/modal/Modal.vue';
  import UploadModal from '../components/modal/UploadModal.vue';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';
  
  import axios from 'axios';

  export default {
    props:{
      websiteid: {
        type: String
      },
      readonly: {
        type: Boolean
      }
    },
    data: function (){
      return {
        msgtext: '',
        msgclass: 'error',
        loading: false,
        settingspage: {},
        imageModal: false,
        file: '',
        imageroot: process.env.VUE_APP_ROOT_API + '/',
        images: [],
        imagetarget: ''
      }
    },
    components: {
      InputDefault,
      AlertBar,
      Loader,
      Modal,
      UploadModal
    },
    methods: {
      setblockimage(image){
          if(this.imagetarget == 'logo'){
            this.settingspage.logoimage = this.imageroot+image.split("uploads/").pop()
          }
      },
      setfavicon(image){
          this.settingspage.favicon = this.imageroot+image.split("uploads/").pop()
      },
      getimages(){
          const requestOptions = {
            headers: authHeader()
          }

          axios.get(process.env.VUE_APP_ROOT_API+'/media/'+this.websiteid, requestOptions)
          .then(response => {
              this.images = response.data.response
          })
      },
      saveSettings(){
          const requestOptions = {
            headers: authHeader()
          }

          const data = {
              websiteid: this.$route.params.websiteid,
              dbentry: 'settings',
              content: [this.settingspage]
          }

          axios.patch(process.env.VUE_APP_ROOT_API+'/settings/', data, requestOptions)
          .then(response => {
              document.getElementById('userframe').contentWindow.location.reload();
          })
      },
      getSettings(){
          axios.get(process.env.VUE_APP_ROOT_API+'/settings/'+this.websiteid)
          .then(response => {
              this.settingspage = response.data.response.settings[0]
          })
      }
    },
    mounted(){
      this.getSettings()
    }
  }
</script>

<style>
#options-bar{
  width: 100%;
} 
#iframecontainer{
  display: none !important;
}
@media (min-width: 700px) {
  #options-bar{
    width: 500px;
  } 
#iframecontainer{
  display: flex !important;
}
}
</style>
